<template>
  <div class="my-like-empty">
    <img src="../../assets/images/mypooq/icon-error-74.png" alt="">
    <p v-html="text"></p>
  </div>
</template>

<script>
export default {
  name: 'EmptyList',
  props: {
    text: {
      type: String
    }
  }
}
</script>

<style lang="css" src="@/assets/css/mypooq.css"></style>
